import { render, staticRenderFns } from "./bugList.vue?vue&type=template&id=5c78cc61&scoped=true&"
import script from "./bugList.vue?vue&type=script&lang=js&"
export * from "./bugList.vue?vue&type=script&lang=js&"
import style0 from "./bugList.vue?vue&type=style&index=0&id=5c78cc61&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c78cc61",
  null
  
)

export default component.exports